import { render, staticRenderFns } from "./PassoCodigoConfirmacao.vue?vue&type=template&id=570ab137"
import script from "./PassoCodigoConfirmacao.vue?vue&type=script&lang=js"
export * from "./PassoCodigoConfirmacao.vue?vue&type=script&lang=js"
import style0 from "./PassoCodigoConfirmacao.vue?vue&type=style&index=0&id=570ab137&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VForm,VSheet,VTextField})
